"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Checkbox = {
    baseStyle: {
        control: {
            _invalid: {
                borderColor: 'red.base',
            },
        },
    },
    variants: {
        dark: {
            container: {
                display: 'flex',
                alignItems: 'flex-start',
            },
            control: {
                width: '20px',
                height: '20px',
                borderRadius: '0',
                _checked: {
                    bg: 'black.base',
                    borderColor: 'black.base',
                },
                _invalid: {
                    borderColor: 'red.base',
                },
            },
        },
    },
};
exports.default = Checkbox;
